var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("span", [
    _c("img", {
      staticClass: "icon",
      attrs: { src: _setup.image, alt: _setup.altText },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }